import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDSelectBox from "components/MDSelectBox";
import { useFormik } from "formik";
import { initialValues } from "./Schemas/initialValue";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import { addAdminApi } from "Apis/admin";
import { updateAdminApi } from "Apis/admin";
import ImageUploader from "components/MDImageUploader";
import { AdminContext } from "context/AdminContext";
import { addvalidationSchema, editvalidationSchema } from "./Schemas/validation";
import MDTelInput from "components/MDTelInput";
import SubmitButton from "components/SubmitButton";
import { statusData } from "helpers/constant";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import colors from "assets/theme/base/colors";
import MDTypography from "components/MDTypography";

const AdminForm = ({ getAdminList }) => {
  const { sideNav } = colors;
  const { editData, rolesList } = useContext(AdminContext);
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);

  const { setOpen, formIsEdit } = useContext(ModalContext);
  const [role, setRole] = useState([]);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const [mobileNumber, setMobileNumber] = useState("+91");

  const [visiblePassword, setVisiblePassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });

  const handleSeePassword = (type) => {
    setVisiblePassword((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  //setData in Formik...
  const setDataInFormik = async () => {
    formik.setValues(editData);
    formik.setFieldValue("image", editData?.admin_images[0]?.image.split("/").pop());
    setMobileNumber("+" + editData?.country_code + editData?.mobile_number.toString());
    formik.setFieldValue("country_code", editData?.country_code);
    formik.setFieldValue("mobile_number", editData?.mobile_number);

    setProfileImage({
      url: editData?.admin_images[0]?.image || null,
      name: null,
    });
  };

  const getRoleLabel = (id) => {
    const role = rolesList.find((item) => item.value === id);
    return role ? role.label : "-";
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  useEffect(() => {
    if (formIsEdit) {
      setDataInFormik();
      setRole(
        editData.role_id ? { label: getRoleLabel(editData.role_id), value: editData.role_id } : null
      );
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    } else if (formIsEdit === false) {
      setProfileImage({
        url: null,
        name: null,
      });
    }
  }, []);

  //HandleSubmit Form
  const handleSubmit = async (values) => {
    if (!formIsEdit) {
      let response = await addAdminApi(values);
      if (response?.status === 200) {
        getAdminList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let response = await updateAdminApi(values);
      if (response?.status === 200) {
        getAdminList();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
        setOpen(false);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    }
  };

  //Formik
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formIsEdit ? editvalidationSchema : addvalidationSchema,
    onSubmit: handleSubmit,
  });

  const handleAutocompleteChange = (value) => {
    if (value) {
      formik.setFieldValue("role_id", value.value);
      setRole(value);
    } else {
      formik.setFieldValue("role_id", null);
      setRole(null);
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const handlePhoneValueChange = (newPhone) => {
    setMobileNumber(newPhone?.numberValue);
    formik.setFieldValue("country_code", newPhone?.countryCallingCode);
    formik.setFieldValue("mobile_number", newPhone?.nationalNumber);
  };

  const passwordRequirements = [
    "Min six characters (ન્યૂનતમ છ અક્ષરો)",
    "At least one digit (ઓછામાં ઓછું એક અંક હોવો જોઈએ)",
    "At least one lowercase letter (એક નાનું (a-z) અક્ષર જરૂર હોવું જોઈએ)",
    "At least one uppercase letter (એક મોટાં (A-Z) અક્ષર હોવું જોઈએ)",
    "At least one special character (ઓછામાં ઓછું એક વિશેષ ચિહ્ન હોવું જોઈએ)",
  ];

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        {/* Image */}
        <MDBox sx={{ fontSize: "16px", fontWeight: "400", marginBottom: "5px", marginTop: "10px" }}>
          Profile Image <span style={{ color: "red" }}>*</span>
        </MDBox>
        <MDBox mb={2} className="metromonial_image">
          <MDBox className="metromonial_message">
            <ImageUploader
              img={profileImage.url}
              folderName={"/admins"}
              name={"image"}
              fileName={"image"}
              formik={formik}
              label="Profile Image"
              hideLabel={true}
            />
            {formik.touched.image && formik.errors.image && (
              <MDBox
                sx={{
                  fontSize: "12px",
                  color: "red",
                  marginRight: "20px",
                  marginTop: "5px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {formik.errors.image}
              </MDBox>
            )}
          </MDBox>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ "@media (max-width: 768px)": { paddingTop: "5px !important" } }}
          >
            <MDBox
              sx={{
                fontSize: "14px",
                width: "100%",
                paddingLeft: "20px",
                paddingTop: "15px",
                "@media (max-width: 768px)": {
                  display: "block",
                  paddingLeft: "0px",
                },
              }}
            >
              Image can't be larger than 5 MB
              <span
                style={{
                  marginTop: "2px",
                  display: "block",
                }}
              >
                (છબીનું કદ 5 mb કરતાં ઓછું હોવું જરૂરી છે)
              </span>
            </MDBox>
          </Grid>
        </MDBox>

        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {/* First Name */}
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="first_name"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="First Name (તમારું નામ)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.first_name && formik.errors.first_name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.first_name}
              </MDBox>
            )}
          </Grid>

          {/* Last Name */}
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="last_name"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Last Name (અટક)"
              variant="standard"
              required
            />
            {formik.touched.last_name && formik.errors.last_name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.last_name}
              </MDBox>
            )}
          </Grid>

          {/* Email */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "22px !important" }}>
            <MDInput
              type="text"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Email"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.email && formik.errors.email && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.email}
              </MDBox>
            )}
          </Grid>

          {/* Mobile No. */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "16px !important" }}>
            <MDTelInput
              name="mobile_number"
              value={mobileNumber}
              handleChange={(event) => handlePhoneValueChange(event)}
              onBlur={formik.handleBlur}
              label="Mobile No"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.mobile_number && formik.errors.mobile_number && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.mobile_number}
              </MDBox>
            )}
          </Grid>

          {formIsEdit === false && (
            <>
              {/* Password */}
              <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
                <MDInput
                  type={!visiblePassword?.newPassword ? "password" : "text"}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  label="Password"
                  sx={{ width: "100%" }}
                  variant="standard"
                  required
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => handleSeePassword("newPassword")}
                          edge="end"
                          size="large"
                        >
                          {!visiblePassword?.newPassword ? (
                            <VisibilityOff sx={{ width: "25px", height: "25px" }} />
                          ) : (
                            <Visibility sx={{ width: "25px", height: "25px" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.password && formik.errors.password && (
                  <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                    {formik.errors.password}
                  </MDBox>
                )}
              </Grid>
            </>
          )}

          {/* Role */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="role_id"
              defaultValue={role}
              options={rolesList}
              handleChange={(value) => handleAutocompleteChange(value)}
              label="Role"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.role_id && formik.errors.role_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.role_id}
              </MDBox>
            )}
          </Grid>

          {formIsEdit === false && (
            <>
              {/* Confirm Password */}
              <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
                <MDInput
                  type={!visiblePassword?.confirmPassword ? "password" : "text"}
                  name="confirm_password"
                  value={formik.values.confirm_password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  label="Confirm Password"
                  sx={{ width: "100%" }}
                  variant="standard"
                  required
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => handleSeePassword("confirmPassword")}
                          edge="end"
                          size="large"
                        >
                          {!visiblePassword?.confirmPassword ? (
                            <VisibilityOff sx={{ width: "25px", height: "25px" }} />
                          ) : (
                            <Visibility sx={{ width: "25px", height: "25px" }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {formik.touched.confirm_password && formik.errors.confirm_password && (
                  <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                    {formik.errors.confirm_password}
                  </MDBox>
                )}
              </Grid>
            </>
          )}

          {/* status */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>

        {formIsEdit === false && (
          <>
            <MDBox mt={6} mb={1}>
              <MDBox fontSize="20px" fontWeight="600" color={sideNav.textColor}>
                Password requirements (પાસવર્ડના નિયમો)
              </MDBox>
            </MDBox>
            <MDBox mb={1}>
              <MDTypography variant="body2" color="text">
                Please follow this guide for a strong password
              </MDTypography>
            </MDBox>
            <MDBox mt={1}>
              {passwordRequirements.map((requirement, index) => (
                <MDBox key={index} sx={{ fontSize: "13px", color: "gray" }}>
                  - {requirement}
                </MDBox>
              ))}
            </MDBox>
          </>
        )}

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};
AdminForm.propTypes = {
  getAdminList: PropTypes.func,
};
export default AdminForm;
